(function () {
    
    $.fn.iSelectGray = function (options = {}, data = []) {
        return this.each (function (index) {
            const $select = $ (this);
            
            const dropName = $select.data ("drop-name");
            const inputPlaceholder = $select.data ("input-placeholder");
            const inputName = $select.data ("input-name");
            const inputClass = $select.data ("input-class");
            
            const arItems = [];
            let activeIndex;
            let activeVal;
    
            $ (".i-select-gray__dropdown[data-name=\"" + dropName + "\"]").remove ();
            
            $select.find (".i-select-gray__op").each (function (i, op) {
                const $_this = $ (op);
                if ($_this.attr ("data-active") !== undefined) {
                    activeIndex = i;
                    activeVal = $_this.attr ("data-value");
                }
                arItems.push ({"value": $_this.attr ("data-value"), "text": $_this.text ()});
            });
            
            if (arItems.length > 0) {
                let text = inputPlaceholder || "";
                
                if (activeIndex !== undefined) {
                    activeVal = arItems[activeIndex];
                    text = arItems[activeIndex]["text"] || text;
                    $select.addClass ("_set");
                }
                
                $select.addClass ("_init").html (
                    `<input class="i-select-gray__value ${inputClass}" type="hidden" value="${(activeVal !== undefined) ? activeVal : ""}" name="${inputName}"><div class="i-select-gray__input"><div class="i-select-gray__input-val">${text}</div></div>`);
                
                const $drop =
                    $ ($ (`<div class="i-select-gray__dropdown" data-name="${dropName}"><div class="i-select-gray__dropdown-inner"><div class="i-select-gray__list"></div></div></div>`)
                        .appendTo ("body").get (0));
                
                let itemsHtml = "";
                $.each (arItems, function (i, item) {
                    itemsHtml += `<div class="i-select-gray__item${(i === activeIndex) ? " _selected" : ""}" data-val="${item.value}"><div class="i-select-gray__item-text">${item.text}</div></div>`;
                });
                
                $drop.find (".i-select-gray__list").append (itemsHtml);
                
            } else {
            
            }
        });
    };
    
    $ (function () {
        $ (".i-select-gray").each (function () {
            const $_this = $ (this);
            if (!$_this.is("[data-prevent-autoinit]")) {
                $ (this).iSelectGray ();
            }
        });
        
        $ (document).on ("click", ".i-select-gray__input", function (e) {
            e.preventDefault ();
            const $input = $ (this);
            if ($input.hasClass ("_disabled")) return false;
            
            const $selectBlock = $input.closest (".i-select-gray");
            const $drop = $ (".i-select-gray__dropdown[data-name=\"" + $selectBlock.attr ("data-drop-name") + "\"]");
            if ($drop.length === 0) return false;
            
            const selectPos = {
                left: $selectBlock.offset ().left,
                top: $selectBlock.offset ().top
            };
            const selectWidth = $selectBlock.outerWidth ();
            const selectHeight = $selectBlock.height ();
            
            
            $ (".i-select-gray__dropdown, .i-select-gray").removeClass ("_open");
            
            $drop.css ({
                left: selectPos.left + "px",
                top: (selectPos.top + selectHeight - 1) + "px",
                width: selectWidth + "px"
            });
            
            $drop.addClass ("_open");
            $selectBlock.addClass ("_open");
            
            const $inner = $drop.find (".i-select-gray__dropdown-inner");
            new SimpleBar ($inner[0]);
        });
        
        $ (document).on ("click", ".i-select-gray__item", function (e) {
            e.preventDefault ();
            const $target = $ (this);
            if ($target.hasClass ("_selected")) return false;
            const $drop = $target.closest (".i-select-gray__dropdown");
            $drop.find (".i-select-gray__item").removeClass ("_selected");
            $drop.trigger ("is:change", [$drop.attr ("data-name"), $target.attr ("data-val"), $target.text ()]);
        });
        
        $ (document).on ("is:change", ".i-select-gray__dropdown", function (e, name, value, text) {
            $ (".i-select-gray").each (function () {
                const $_this = $ (this);
                if ($_this.attr ("data-drop-name") === name) {
                    $_this.addClass("_set");
                    $_this.find (".i-select-gray__value").val (value);
                    $_this.find (".i-select-gray__input-val").text (text);
                    $_this.trigger ("is:change");
                }
            });
        });
        
        $ (window).on ("resize", function () {
            $ (".i-select-gray__dropdown._open").each (function () {
                const $dropdown = $ (this);
                $ (".i-select-gray[data-drop-name=\"" + $dropdown.attr ("data-name") + "\"]").each (function () {
                    const $select = $ (this);
                    const selectPos = {
                        left: $select.offset ().left,
                        top: $select.offset ().top
                    };
                    const selectWidth = $select.outerWidth ();
                    const selectHeight = $select.height ();
                    $dropdown.css ({
                        left: selectPos.left + 'px',
                        top: (selectPos.top + selectHeight - 1) + 'px',
                        width: selectWidth + 'px'
                    });
                });
            })
        });
        
        //Outside click
        $ (document).on ("click", function (e) {
            if (!e.target.closest ('.i-select-gray')) {
                $ ('.i-select-gray__dropdown, .i-select-gray').removeClass ('_open');
            }
        });
    })
}) ();
